import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import {
    getTransactiondepositPayment,
    getTransactiondepositOther,
    getTransactiondepositCash
    ,
} from "../../../api/deposit";
import {
    depositother_Tab_Table,
    depositcash_Tab_Table,
  depositPayments_Tab_Table,
} from "../../../config/grid-column-defs";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Checkbox,
  InputLabel,
  MenuItem,
  Tabs,
  Tab,
  FormControl,
  Select,
  FormControlLabel,
  FormGroup,
  CircularProgress,
  Stack,
  Button,
} from "@mui/material";
import TabPanel from "../../../components/TabPanel";

export default function DepositTab() {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [amountSum,setAmount]=useState("")
  const [depositsum,setdepositsum]=useState("")
  const [cashbacksum,setcashbacksum]=useState("")
  
  const pageDetail = slugMap[params.slug];

  const [rowData, setRowData] = useState([]);

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  // useEffect(() => {
  //   if (user.token) {
  //     getTransactionPaymentData();
  //   }
  // }, [user.token]);

  async function getTransactionPaymentData() {
   
    try {
      const { data } = await getTransactiondepositPayment(user.token, {
        id: params.docNo,
      });
      setAmount(data.data.TotalAmount?.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      }))
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  }
  async function getTransactionOtherData() {
   
    try {
      const { data } = await getTransactiondepositOther(user.token, {
        id: params.docNo,
      });
      setdepositsum(data.data.depositsum)
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  }
  async function getTransactionCashData() {
   
    try {
      const { data } = await getTransactiondepositCash(user.token, {
        id: params.docNo,
      });
      setcashbacksum(data.data.cashbacksum)
      return { rows: data.data.data, total: data.data.total, error: false };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
    }
  }

  return (
    <>
      <Box>
        <Box
          sx={{
            maxWidth: { xs: "100%", sm: "100%", md: "100%" },
            bgcolor: "#fff",
            px: 2,
          }}
        >
          <Grid container m={1}>
         
          </Grid>
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-sub-bkg"
          >
            <Tab label={`Payments ${amountSum||"0.00"}`} style={{margin:"10px"}} />
            <Tab label={`Other Deposits ${depositsum||"0.00"}`} style={{margin:"10px"}} />
            <Tab label={`Cash Back ${cashbacksum||"0.00"}`} />
            {/* <Tab label="User Notes" /> */}
          </Tabs>
          {/*----------Payments------------*/}
          <TabPanel value={tabIndex} index={0}>
            <AgGridPaginatedTable
              getTableRows={getTransactionPaymentData}
              columns={depositPayments_Tab_Table}
              refreshCounter={0}
            />
          </TabPanel>
          {/*----------Other Deposits------------*/}
          <TabPanel value={tabIndex} index={1}>
          <AgGridPaginatedTable
                getTableRows={getTransactionOtherData}
                columns={depositother_Tab_Table}
                refreshCounter={0}
              />
          </TabPanel>
          {/*----------Files------------*/}
          <TabPanel value={tabIndex} index={2}>
            <Box className="viewDetilsBox">
              <AgGridPaginatedTable
                getTableRows={getTransactionCashData}
                columns={depositcash_Tab_Table}
                refreshCounter={0}
              />
            </Box>
          </TabPanel>
         
        </Box>
      </Box>
    </>
  );
}
